<template>
  <div class="rounded-lg p-3 bg-white mb-2">
    <div class="flex items-center">
      <div class="fs-20 fw-500">{{ name }}</div>
      <div @click="openCreateIndication()"
        class="cursor-pointer ml-auto p-2 w-36 rounded-lg border border-primary flex justify-center items-center">
        <img src="@public/assets/images/icon/patientVisit/plus-circle.svg" alt />
        <p class="ml-2 text-primary font-weight-bold mb-0">{{ $t("schedule_page.lbl_designation") }}</p>
      </div>
    </div>
    <div class="mt-2" v-if="ordersLocal && ordersLocal.length">
      <el-collapse class="hodo-el-collapse" v-model="activeCollapseItems" @change="handleChangeCollapse">
        <el-collapse-item :name="`collapse-${index}`"
          v-for="(item, index) in ordersLocal.filter(order => Array.isArray(order.indications) && order.indications.length > 0)"
          :key="item.id">
          <template slot="title">
            <div class="w-full flex items-center justify-between">
              <div class="flex items-center font-medium txt-pri hover:text-blue-600 transition-all duration-200">
                <i class="el-icon-arrow-right collapse-arrow mr-2"
                  :class="{ rotated: activeCollapseItems.includes(`collapse-${index}`) }"
                  @click.stop="toggleCollapse(index)"></i>
                <span class="mr-1">{{ `${$t(item.name)} (${item.indications.length})` }}</span>
              </div>
              <div class="flex items-center">
                <template v-if="!item.id">
                  <el-button size="mini" class="action-btn mx-1 text-primary" @click.stop="openUpdateIndication(item)">
                    <i class="el-icon-edit"></i>
                  </el-button>
                  <el-button size="mini" class="action-btn mx-1 text-danger"
                    @click.stop="confirmDelete(item.id, index)">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </template>
              </div>
            </div>
          </template>
          <div>
            <div v-for="(indication, index) in item.indications" :key="indication.id"
              :class="index < item.indications.length ? 'border-b border-t-0 border-r-0 border-l-0 border-solid border-gray-200' : ''"
              class="group flex justify-between hover:bg-gray-100 transition-all duration-200 px-2 py-1" role="button">
              <div class="relative transition-all duration-200 w-full pr-2 cursor-pointer flex-1">
                <svg v-if="indication && indication.document_link" class="cursor-pointer mr-1" width="30" height="30"
                  viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" stroke="#20409B" />
                  <mask id="mask0_35008_774" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="6" y="6" width="18"
                    height="18">
                    <rect x="6.92859" y="6.92871" width="16.1429" height="16.1429" fill="#D9D9D9" stroke="#20409B" />
                  </mask>
                  <g mask="url(#mask0_35008_774)">
                    <path
                      d="M15 17.8701C15.8962 17.8701 16.6583 17.5563 17.2857 16.9289C17.913 16.3015 18.2268 15.5394 18.2268 14.6433C18.2268 13.7471 17.913 12.985 17.2857 12.3577C16.6583 11.7303 15.8962 11.4165 15 11.4165C14.1039 11.4165 13.3418 11.7303 12.7144 12.3577C12.087 12.985 11.7732 13.7471 11.7732 14.6433C11.7732 15.5394 12.087 16.3015 12.7144 16.9289C13.3418 17.5563 14.1039 17.8701 15 17.8701ZM15 16.5593C14.4676 16.5593 14.0154 16.3731 13.6428 16.0005C13.2702 15.6279 13.084 15.1757 13.084 14.6433C13.084 14.1108 13.2702 13.6587 13.6428 13.286C14.0154 12.9134 14.4676 12.7272 15 12.7272C15.5325 12.7272 15.9846 12.9134 16.3573 13.286C16.7299 13.6587 16.9161 14.1108 16.9161 14.6433C16.9161 15.1757 16.7299 15.6279 16.3573 16.0005C15.9846 16.3731 15.5325 16.5593 15 16.5593ZM15 19.9879C13.2644 19.9879 11.6835 19.5035 10.257 18.5347C8.83193 17.5668 7.7984 16.2698 7.15632 14.6433C7.7984 13.0168 8.83193 11.7197 10.257 10.7518C11.6835 9.78301 13.2644 9.29863 15 9.29863C16.7356 9.29863 18.3165 9.78301 19.743 10.7518C21.1681 11.7197 22.2016 13.0168 22.8437 14.6433C22.2016 16.2698 21.1681 17.5668 19.743 18.5347C18.3165 19.5035 16.7356 19.9879 15 19.9879Z"
                      fill="#20409B" stroke="#20409B" stroke-width="0.025" />
                  </g>
                </svg>
                <span class="txt-pri">{{ indication.name || indication.local_name || (indication.service_catalog &&
                  indication.service_catalog.name) }}</span>
              </div>
              <div class="mr-3">{{ `x ${indication.indicationAmount || 1}` }}</div>
              <div class="italic text-right whitespace-nowrap" :set="(status = hasExaminationResults(indication))">
                <span :class="status.class">{{ status.text }}</span>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <custom-modal :showModal="showIndicationModal" size="w-full" @hideModal="onHideModal"
      :title="indicationOrderDetail ? $t('Chỉnh sửa/ Thay đổi phiếu chỉ định') : $t('Tạo phiếu chỉ định')"
      titleClass="uppercase text-3xl w-full text-center" :esc-close="true">
      <CUInficationOrder v-if="showIndicationModal" :type="type"
        :order="(editingIndex !== null && ordersLocal[editingIndex]) ? ordersLocal[editingIndex] : (indicationOrderDetail || {})"
        :mr_id="form && form.medical_record_id" :hr_id="form && form.health_record_id" @refresh="onRefresh"
        @update="onUpdateOrders" />
    </custom-modal>

  </div>
</template>

<style scoped lang="scss">
::v-deep {
  .hodo-el-collapse {
    .el-collapse-item {
      &__header {
        height: auto;
        line-height: normal;
        padding: 8px 0;
      }

      &__wrap {
        border-bottom: none;
      }

      &__content {
        padding-bottom: 8px;
      }

      &__header {
        & .el-collapse-item__arrow {
          display: none !important;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.collapse-arrow {
  font-size: 14px;
  line-height: 1;
  transition: transform 0.12s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.collapse-arrow.rotated {
  transform: rotate(90deg);
}

.action-btn {
  padding: 4px;
  border-radius: 50%;
  min-width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: none !important;
  color: inherit;
  transition: background-color 0.12s ease, transform 0.12s ease, border-color 0.12s ease;
}

.action-btn i {
  font-size: 14px;
  line-height: 1;
  color: inherit;
  opacity: 1 !important;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.action-btn.text-primary:hover {
  background-color: var(--hodo-primary, #1e90ff) !important;
}

.action-btn.text-danger:hover {
  background-color: var(--hodo-danger, #ef4444) !important;
}

.action-btn.text-primary:hover i,
.action-btn.text-danger:hover i {
  color: #fff !important;
}
</style>

<script>

import CustomModal from '@/components/CustomModal'
import appUtils from '@/utils/appUtils'
import {
  EXAMINATION_STATUS,
  INDICATION_STATUS
} from '@/utils/constants'
import moment from 'moment'
import CUInficationOrder from './Components/CUInficationOrder.vue'

export default {
  name: 'IndicationTemp',
  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    },
    form: {
      type: Object,
      default: () => ({})
    },
    reset: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: undefined
    }
  },
  components: {
    CustomModal,
    CUInficationOrder

  },
  data () {
    return {
      appUtils,
      editingIndex: null,
      showIndicationModal: false,
      showIndicationOrderDetail: false,
      showIndicationDetail: false,
      indicationOrderDetail: null,
      indicationDetail: {},
      INDICATION_STATUS,
      activeCollapseItems: ['collapse-0'],
      EXAMINATION_STATUS
    }
  },
  computed: {
    ordersLocal () {
      return Array.isArray(this.items) ? [...this.items] : []
    }
  },
  watch: {
    reset (newVal) {
      if (newVal) {
        this.ordersLocal = []
      }
    }
  },
  methods: {
    handleChangeCollapse (val) { },
    getIndicationStatus (stt) {
      switch (stt) {
        case INDICATION_STATUS.CODE.PENDING:
          return {
            text: this.$t('Chưa có KQ'),
            class: `text-yellow-600`
          }
        case INDICATION_STATUS.CODE.HAS_RESULT:
          return {
            text: this.$t('Đã có KQ'),
            class: `text-green-700`
          }
        case INDICATION_STATUS.CODE.CS:
          return {
            text: this.$t('Có dấu hiệu bất thường'),
            class: `text-red-600`
          }
        case INDICATION_STATUS.CODE.NCS:
          return {
            text: this.$t('Không có dấu hiệu bất thường'),
            class: `text-blue-800`
          }
        default:
          break
      }
    },
    hasExaminationResults (data) {
      if (data?.examination_result?.id) {
        return {
          text: this.$t('Đã có KQ'),
          class: `text-green-700`
        }
      }
      if (data?.status === 3) {
        return {
          text: this.$t('Đã hủy'),
          class: `text-red-600`
        }
      } else {
        return {
          text: this.$t('Chưa có KQ'),
          class: `text-yellow-600`
        }
      }
    },
    openCreateIndication () {
      this.indicationOrderDetail = null
      this.editingIndex = null
      this.showIndicationModal = true
    },
    onHideModal (hasQuery, isGoBack) {
      this.showIndicationModal = false
      this.showIndicationOrderDetail = false
      this.showIndicationDetail = false
    },
    onRefresh (isHide = true) {
      isHide && this.onHideModal()
      this.$emit('refresh')
    },
    onUpdateOrders (newOrder) {
      if (newOrder) {
        // Ensure unsaved orders get a stable local id so we can match them later
        if (!newOrder.id && !newOrder._local_id) {
          newOrder._local_id = `local_${Date.now()}_${Math.floor(Math.random() * 10000)}`
        }

        // If editingIndex is set, replace the existing order at that index.
        if (this.editingIndex !== null && this.editingIndex >= 0 && this.editingIndex < this.ordersLocal.length) {
          // preserve _local_id if present on existing item
          const existing = this.ordersLocal[this.editingIndex] || {}
          if (existing._local_id && !newOrder._local_id) newOrder._local_id = existing._local_id
          this.$set(this.ordersLocal, this.editingIndex, newOrder)
          const collapseName = `collapse-${this.editingIndex}`
          if (!this.activeCollapseItems.includes(collapseName)) this.activeCollapseItems.push(collapseName)
        } else {
          // New order: ensure it has a _local_id
          if (!newOrder._local_id) newOrder._local_id = `local_${Date.now()}_${Math.floor(Math.random() * 10000)}`
          this.ordersLocal.push(newOrder)
          const newIndex = this.ordersLocal.length - 1
          const newCollapseName = `collapse-${newIndex}`
          if (!this.activeCollapseItems.includes(newCollapseName)) {
            this.activeCollapseItems.push(newCollapseName)
          }
        }
      }
      this.$emit('update', { type: this.type, data: this.ordersLocal })
      this.onHideModal()
      // reset editingIndex after update
      this.editingIndex = null
    },
    onReloadPage () {
      this.$emit('refresh')
    },
    onHandleViewIndication (item) {
      if (!item || typeof item === 'undefined') return
      this.indicationOrderDetail = item
      this.showIndicationOrderDetail = true
      this.$emit('openIndicationOrderModal', item)
    },
    openUpdateIndication (item) {
      if (!item || typeof item === 'undefined') return
      // Prefer matching by internal _local_id for unsaved items, fallback to id
      const idx = this.ordersLocal.findIndex(o => {
        if (!o) return false
        if (o._local_id && item._local_id) return o._local_id === item._local_id
        if (o.id && item.id) return o.id === item.id
        // fallback to object identity
        return o === item
      })
      this.editingIndex = idx !== -1 ? idx : null
      this.indicationOrderDetail = item
      this.$nextTick(() => {
        this.showIndicationModal = true
      })
    },
    onHandleViewIndicationResult (item) {
      if (!item || typeof item === 'undefined') return
      if (item?.status === 3) {
        this.$message({
          type: 'warning',
          message: this.$t('Xét nghiệm này đã hủy, bạn không thể xem chi tiết.')
        })
        return
      }
      this.indicationDetail = item
      this.showIndicationDetail = true
      this.$emit('openIndicationResultModal', item)
    },
    toggleCollapse (index) {
      const name = `collapse-${index}`
      if (this.activeCollapseItems.includes(name)) {
        this.activeCollapseItems = this.activeCollapseItems.filter(n => n !== name)
      } else {
        this.activeCollapseItems.push(name)
      }
    },
    confirmDelete (id, idx) {
      this.$confirm(this.$t('Bạn có chắc muốn xóa phiếu chỉ định này?'), this.$t('Xác nhận'), {
        confirmButtonText: this.$t('Xóa'),
        cancelButtonText: this.$t('Hủy'),
        type: 'warning'
      })
        .then(() => {
          if (!id) {
            const arr = this.ordersLocal
            arr.splice(idx, 1)
            this.$emit('update', { type: this.type, data: arr })
          } else {
            const arr = this.ordersLocal.filter(o => o.id !== id)
            this.$emit('update', { type: this.type, data: arr })
          }
          const collapseName = `collapse-${idx}`
          this.activeCollapseItems = this.activeCollapseItems.filter(n => n !== collapseName)
        })
        .catch(() => { })
    },
    handleOpenResult (indication) {
      if (indication?.document_link) {
        window.open(indication.document_link, '_blank', 'noreferrer')
      }
    },
    getUpdatedAt (item) {
      const date = moment(item.updated_at)
      return appUtils.formatDateTimeFull(date)
    }
  }
}
</script>
